import React from "react";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import NanoFlex from "../../Global/NanoFlex.js";
import Button from "../../Nano/Buttons/Button.js";
import Type from "../../Global/Typography.js";
import iconWarning from "../../Global/Icons/warning.svg";

const WarningContentStyle = styled.div`
  padding: 24px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  .modalContainer {
    max-width: 350px;
    .modalTitle {
      padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
      img {
        margin-right: ${nota.global.multiple * 2 + "px"}; /*16px*/
      }
    }
    .infoContainer {
      padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
      max-height: 500px;
      min-height: 100px;
      overflow: auto;
      text-align: center;
    }
    .btnsContainer {
      height: 50px;
      padding: ${nota.global.multiple * 2 + "px"}; /*16px*/
      padding-bottom: 0;
      margin: 0;
      border-top: 0.5px solid ${nota.color.neutral.NeuTwo};
    }
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    width: 90vw;
    .modalContainer {
      max-width: 100%;
      .btnsContainer {
        height: auto;
        flex-direction: column;
        padding-top: 0;
        .buttonWrapper {
          order: 1;
          .cta {
            margin-bottom: 0;
          }
        }
        .simpleButtonWrapper {
          order: 2;
          margin-top: 8px;
        }
      }
    }
  }
`;

const WarningContent = (props) => {
  return (
    <WarningContentStyle>
      <NanoFlex className="modalContainer" flexDirection={"column"} flexWrap={"wrap-reverse"} justifyContent={"space-around"} alignContent={"center"}>
        <NanoFlex className="modalTitle" justifyContent={"flex-start"} alignItems={"flex-end"}>
          <img src={iconWarning} alt="warning" />
          <Type.h2>WARNING</Type.h2>
        </NanoFlex>
        <NanoFlex className="infoContainer">
          <Type.p>Another user is already logged in with the same credentials. If you continue the other session will be closed.</Type.p>
        </NanoFlex>
        <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
          <Button label={"CANCEL"} simple clickAction={() => props.cancelAction()} />
          <Button label={"confirm"} clickAction={() => props.nextAction()} />
        </NanoFlex>
      </NanoFlex>
    </WarningContentStyle>
  );
};

// Set default props
WarningContent.defaultProps = {
  info: "",
  cancelAction: () => null,
  nextAction: () => null,
};

export default WarningContent;

/*
Doc
import WarningContent from '../../Micro/Warning.js';

<WarningContent
    cancelAction={() => console.log('cancelAction')}
    nextAction={() => console.log('nextAction')}
/>
*/
